//exports.api_endpoint = "https://ycbl-shop.devistorm.fr/api";
//exports.api_endpoint = "http://localhost:3001/api";

exports.api_endpoint = "/api";
